<template>
    <div>
        <div v-for="field in entry.fields" :key="field.id">
            <p class="form-label"><b>Q: {{field.label.EN}}</b></p>
            <p class="mt-2" v-if="field.valueType === 'MULTIPLE_OPTION'">
                <b>A:</b>
                <span v-for="(v, vindex) in field.value" :key="vindex">
                    {{v.EN}}
                    <span v-if="vindex < (field.value.length - 1)">,</span>
                </span>
            </p>
            <p class="mt-2" v-else-if="field.valueType === 'OPTION'">
                <b>A:</b> {{field.value.EN}}
            </p>
            <p class="mt-2" v-else-if="field.valueType === 'DATE'">
                <b>A:</b> {{field.value | formatDateTime}}
            </p>
            <p class="mt-2" v-else><b>A:</b> {{field.value}}</p>
            <el-divider/>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FormEntryPreview',
    props: {
        entry: Object,
    },
    data: function() {
        return {
            locValue: {},
        }
    },
    methods: {

    },
    mounted() {

    },
    watch: {

    }
}
</script>